/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import AbsenteeCalendar from "./AbsenteeCalendar";
import Absentee from "./Absentee";
import Worker from "./Worker";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

const AttendanceWorkDepartment = (props) => {
  const history = useHistory();
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [activeTab, setActiveTab] = useState(0);
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'WORK_HISTORY')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "WORK_HISTORY")
      }
    }
  }, [permissions])

  const _setActiveTab = (value) => {
    history.push(`/attendance/work-department?tab=${value}`);
  };

  const tabList = [
    {
      label: "근무자",
      action: _setActiveTab,
      value: 'worker'
    },
    {
      label: "부재자 달력보기",
      action: _setActiveTab,
      value: 'absentee-calendar'
    },
    {
      label: "부재자 목록보기",
      action: _setActiveTab,
      value: 'absentee'
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  return (
    !isEmpty(targetPermission) && (
      <div>
        <PageHeader
          title={"부서별 근무 현황"}
          activeTab={activeTab}
          tabList={tabList}
        />
        {activeTab === 'worker' && <Worker />}
        {activeTab === 'absentee-calendar' && <AbsenteeCalendar />}
        {activeTab === 'absentee' && <Absentee />}
      </div>
    )
  );
};

export default AttendanceWorkDepartment;
